import { render, staticRenderFns } from "./ProformaRentalHistory.vue?vue&type=template&id=1a6c6994&scoped=true"
import script from "./ProformaRentalHistory.vue?vue&type=script&lang=js"
export * from "./ProformaRentalHistory.vue?vue&type=script&lang=js"
import style0 from "./ProformaRentalHistory.vue?vue&type=style&index=0&id=1a6c6994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c6994",
  null
  
)

export default component.exports